import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import LoadingScreen from './components/LoadingScreen';
import HelpPrompt from './components/HelpPrompt';
import InterfaceUI from './components/InterfaceUI';
import PortfolioCat from './components/PortfolioCat';
import eventBus from './EventBus';
import './style.css';
const App = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        eventBus.on('loadingScreenDone', () => {
            setLoading(false);
        });
    }, []);
    return (React.createElement("div", { id: "ui-app" },
        !loading && React.createElement(HelpPrompt, null),
        !loading && React.createElement(PortfolioCat, null),
        React.createElement(LoadingScreen, null)));
};
const createUI = () => {
    ReactDOM.render(React.createElement(App, null), document.getElementById('ui'));
};
const createVolumeUI = () => {
    ReactDOM.render(React.createElement(InterfaceUI, null), document.getElementById('ui-interactive'));
};
export { createUI, createVolumeUI };
